<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        extraLarge
        ref="RkmModal"
        title="Cadastrar Medicamento"
    >
        <Form
            :modelReceitaMedica="true"
            @save="save"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from '@/components/cadastro/medicamento/Form'


export default {
    components: { Form },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        save(item) {
            this.$emit('saved', item)
            this.handleExit()
        },
    },
}
</script>